export {
  I18nProvider,
  useI18n,
  useT,
  useMonthLabel,
  useWageCodeLabel,
  type TranslateFn,
} from "./I18nContext";
export {
  translations,
  LANGUAGES,
  type Lang,
  type TranslationKey,
} from "./translations";

import type { ReportStatus } from "@avg/shared";
import type { TranslateFn } from "./I18nContext";

export function reportStatusLabelI18n(
  t: TranslateFn,
  status: ReportStatus,
): string {
  switch (status) {
    case "DRAFT":
      return t("status.draft");
    case "SUBMITTED":
      return t("status.submitted");
    case "MANAGER_APPROVED":
      return t("status.manager_approved");
    case "ADMIN_APPROVED":
      return t("status.admin_approved");
    case "REJECTED":
      return t("status.rejected");
  }
}
